import { createStore } from 'vuex'

export default createStore({
  state: {
    user:{
      token:'zsfdzsfsdfsfz',
      name:'admin',
      role:'管理员'
    }
  },
  getters: {
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.user.token = token
    },
    SET_NAME: (state, name) => {
      state.user.name = name
    },
  },
  actions: {
  },
  modules: {
  }
})
